import { Link } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";
import StarRating from "../StarRating";
import { formatPrice, getDiscountPercent } from "../../utils/formatPrice";
import styles from "./ProductCard.module.css";

function ProductCard({ product, onAddToCart }) {
  const displayPrice = product.salePrice !== null ? product.salePrice : product.price;
  const discount = getDiscountPercent(product);
  const outOfStock = product.stock === 0;

  return (
    <div className={styles.card}>
      <Link to={`/products/${product.id}`} className={styles.imageLink}>
        <img
          src={product.images[0]}
          alt={product.name}
          className={styles.image}
          loading="lazy"
        />
        {discount && (
          <span className={styles.badge}>-{discount}%</span>
        )}
        {outOfStock && (
          <div className={styles.soldOut}>已售完</div>
        )}
      </Link>

      <div className={styles.body}>
        <Link to={`/products/${product.id}`} className={styles.name}>
          {product.name}
        </Link>

        <StarRating rating={product.rating} reviewCount={product.reviewCount} />

        <div className={styles.priceRow}>
          <span className={styles.price}>{formatPrice(displayPrice)}</span>
          {product.salePrice !== null && (
            <span className={styles.originalPrice}>{formatPrice(product.price)}</span>
          )}
        </div>

        <button
          className={styles.addBtn}
          onClick={() => onAddToCart(product)}
          disabled={outOfStock}
          aria-label={`加入 ${product.name} 至購物車`}
        >
          <FaShoppingCart />
          {outOfStock ? "已售完" : "加入購物車"}
        </button>
      </div>
    </div>
  );
}

export default ProductCard;
